/* eslint-disable no-multiple-empty-lines */
/* eslint-disable max-len */

import * as React from "react";
import { Button, Grid, Tab } from "semantic-ui-react";

import { Authorize } from "reauthorize";

import { Detail } from "@neworbit/simpleui-detail";

import Utils from "@teamprevent/common/utils";
import { readonlyCaseTypeOrgStructuresList } from "@teamprevent/common/customerUser/ReadonlyCaseTypeOrgStructures";

import { CoreDetailProps, DetailProps } from "../Detail";
import DeleteButton from "../DeleteButton";
import { CUSTOMER_ROLES } from "../../../../auth/model";

import { CoreDetailsButtons } from "./CoreDetailButtons";

import { Link } from "redux-little-router";

export const CoreDetails: React.FunctionComponent<CoreDetailProps> = (props) => (
    <Grid stackable container className="user-details-grid">
        <Detail label="Customer Id" value={props.customerUser.customerId} labelWidth={5} valueWidth={11} />
        <Detail label="Email Address" value={props.customerUser.emailAddress} labelWidth={5} valueWidth={11} />
        <Detail label="Given Name" value={props.customerUser.firstName} labelWidth={5} valueWidth={11} />
        <Detail label="Surname" value={props.customerUser.surname} labelWidth={5} valueWidth={11} />
        <Detail label="Roles" value={props.customerUser.roles && props.customerUser.roles.join(", ")} labelWidth={5} valueWidth={11} />
        <Detail label="Organisation Structure One" value={props.customerUser.orgStructureOne?.name} labelWidth={5} valueWidth={11} />
        <Detail label="Organisation Structure Two" value={props.customerUser.orgStructureTwo?.name} labelWidth={5} valueWidth={11} />
        <Detail label="Organisation Structure Three" value={props.customerUser.orgStructureThree?.name} labelWidth={5} valueWidth={11} />
        <Detail label="Organisation Structure Four" value={props.customerUser.orgStructureFour?.name} labelWidth={5} valueWidth={11} />
        <Detail
            label="View all cases for"
            value={readonlyCaseTypeOrgStructuresList(props.customerUser.caseTypeOrgStructures, props.orgStructures)}
            labelWidth={5}
            valueWidth={11}
        />
        <Detail label="Active" value={Utils.BoolToString(props.customerUser.active)} labelWidth={5} valueWidth={11} />
    </Grid>
);

const CoreDetailsWithActions: React.FunctionComponent<DetailProps> = (props) => {
    return (
        <div>
            <CoreDetails customerUser={props.customerUser} orgStructures={props.orgStructures} />
            <Grid container className="user-action-buttons">
                <Authorize authorize={[CUSTOMER_ROLES.customerAdministrator.name]}>
                    <DeleteButton />
                    <CoreDetailsButtons customerUser={props.customerUser} orgStructures={props.orgStructures} />
                    <Button secondary content="Edit" as={Link} href={`${props.path}/edit`} />
                </Authorize>
            </Grid>
        </div>
    );
};

export const coreDetailsTab = (props: DetailProps) => ({
    path: "",
    menuItem: "Details",
    authorise: true,
    render: () => <Tab.Pane className="details-tab-pane"><CoreDetailsWithActions {...props} /></Tab.Pane>
});
